import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { Heading, Text, TextareaField, useControlledField } from '@weave/design-system';

interface NotesSectionProps {
  notes: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const NotesSection = ({
  notes,
  onChange,
  readOnly = false,
}: NotesSectionProps) => {
  const controlledFieldProps = useControlledField({
    type: 'text',
    value: notes,
    onChange: (value) => onChange(value),
  });

  const textareaHeightStyle = css`
    textarea {
      height: 120px;
    }
  `;

  return (
    <section>
      <div css={header}>
        <Heading level={2} css={title}>
          Location Information
        </Heading>
        <Text color="light" size="small" css={subtitle}>
          Fill out the information below to add to your handoff note
        </Text>
      </div>
      <div id="handoff-checklist-notes-input">
        <TextareaField
          {...controlledFieldProps}
          name="notes"
          label="Please include any helpful notes and details below (Optional)"
          placeholder="Placeholder Text"
          containerCss={textareaHeightStyle}
          disabled={readOnly}
        />
      </div>
    </section>
  );
};

const header = css`
  margin-bottom: ${theme.spacing(2.5)};
`;

const title = css`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
`;

const subtitle = css`
  margin: 0;
  margin-top: 4px;
`;
